import { Tabs, TabsList, TabsTrigger } from '@/components/ui';
import { VerificationTypesEnum } from '@/lib/enum';
import { useDocumentTitle } from '@/hooks';
import { Link } from 'react-router-dom';
import { useUrlParams } from '../hooks';
import routes from '@/lib/routes';
import { cn } from '@/lib/utils';

const TabMenus = () => {

  const { type, dateString, sortType, authorIds } = useUrlParams();
  useDocumentTitle({
    title: (
      type === VerificationTypesEnum.IDENTITY
        ? 'Historique des certifications'
        : 'Historique des vérifications'
    )
  });

  const getUrlByCategory = (value: VerificationTypesEnum) =>
    routes
      .nav
      .verificationsHistory
      .getHref(value, { sortType: sortType, date: dateString, authorIds });

  return (
    <Tabs className='pt-3 md:pt-5' value={type?.toLowerCase()}>
      <TabsList className={cn(
        'w-full flex justify-center',
        'md:w-auto md:inline-flex'
      )}>
        <TabsTrigger asChild value={VerificationTypesEnum.IDENTITY.toLowerCase()}>
          <Link replace to={getUrlByCategory(VerificationTypesEnum.IDENTITY)}>
            Certifications
          </Link>
        </TabsTrigger>
        <TabsTrigger asChild value={VerificationTypesEnum.PROFILE_PHOTO.toLowerCase()}>
          <Link replace to={getUrlByCategory(VerificationTypesEnum.PROFILE_PHOTO)}>
            Photos
          </Link>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );

};

export default TabMenus;
